import firebase from 'firebase/compat/app'
import { FirebaseRemoteConfigKey } from 'root-constants'

export const getRemoteConfigVariantData = ({
  firebaseRemoteConfig,
  firebaseRemoteConfigKey,
}: {
  firebaseRemoteConfig: firebase.remoteConfig.RemoteConfig | null
  firebaseRemoteConfigKey?: FirebaseRemoteConfigKey | FirebaseRemoteConfigKey[]
}): Record<string, string> | string => {
  if (!firebaseRemoteConfig || !firebaseRemoteConfigKey) {
    return {}
  }

  const getValue = (key: FirebaseRemoteConfigKey) =>
    firebaseRemoteConfig?.getString(key)

  if (Array.isArray(firebaseRemoteConfigKey)) {
    const firebaseRemoteConfigValues: Record<string, string> = {}

    firebaseRemoteConfigKey.forEach((key) => {
      firebaseRemoteConfigValues[key] = getValue(key)
    })

    return firebaseRemoteConfigValues
  }

  return getValue(firebaseRemoteConfigKey)
}
